import { render, staticRenderFns } from "./company-fund-chart.vue?vue&type=template&id=a0c4addc&scoped=true&"
import script from "./company-fund-chart.vue?vue&type=script&lang=js&"
export * from "./company-fund-chart.vue?vue&type=script&lang=js&"
import style0 from "./company-fund-chart.vue?vue&type=style&index=0&id=a0c4addc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c4addc",
  null
  
)

export default component.exports